module.exports = __webpack_public_path__ + "static/media/02korea_n.c68eb5c0.svg";